<template >
  <div class="modal-backdrop"  @click="close">
    <div :class="[{'modal_large': largeModal},{'modal_middle': middleModal}, 'modal']" @click.stop :style="[{width: width, padding: padding}]">
      <perfect-scrollbar :class="{'no-scroll': !scroll}" :style="{height: heightOfScroll + 'px'}">
        <div class="modal-wrapper" :style="[{padding: paddingWithScroll}]">
          <header class="modal-header">
            <span class="modal__title" v-if="title">{{title}}</span>
            <inline-svg
              v-if="showClose"
              class="btn-close" 
              :src="require(`@/assets/svg/close.svg`)"
              @click="close"/>  
          </header>
           <loader v-if="loading" />
           <template v-else>
              <section class="modal-body">
                <slot name="body">
                </slot>
              </section>
              <footer v-if="isFooter" class="modal-footer">
                <slot name="footer">
                </slot>
              </footer>
            </template>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      isFooter: {
        type: Boolean,
        required: false,
        default: true
      },
      heightOfScroll: {
        type: [String, Number],
        required: false
      },
      middleModal: {
        type: Boolean,
        required: false
      },
      largeModal: {
        type: Boolean,
        required: false
      },
      title: {
        type: String,
        required: false
      },
      width: {
        type: String,
        required: false
      },
      padding: {
        type: String,
        required: false
      },
      paddingWithScroll: {
        type: String,
        required: false
      },
      scroll: {
        type: Boolean,
        required: false,
        default: true
      },
      showClose: {
        type: Boolean,
        required: false,
        default: true
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss">
  .footer-bottom {
    position: absolute;
    bottom: 0;
  }
  .no-scroll.ps {
    overflow: inherit !important;
    & .ps__rail-x, & .ps__rail-y {
      display: none !important;
    }
  }
  .modal-backdrop {
    position: fixed;
    z-index: 999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    position: relative;
    padding: 30px 30px 40px 30px;
    width: 630px;
    z-index: 1000;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    &__title {
      font-weight: 600;
      font-size: 24px;
      display: block;
      color: var(--black-title);
      margin-bottom: 30px;
    }
    &-footer {
      margin-top: 30px;
      display: flex;
      align-items: center;
    }
    &_large {
      width: 95%;
    }
    &_middle {
      width: 60%;
    }
  }

  .btn-close {
    position: absolute;
    top: 17px;
    right: 17px;
    border: none;
    cursor: pointer;
    font-weight: bold;
    color: #2196F3;
    background: transparent;
  }

</style>